import { Component, Vue } from 'vue-facing-decorator';
import i18n from '@/locale';
import { User } from '@/types/User';

@Component
export default class RedirectMixin extends Vue {
    goToOnboarding(data: any): void {
        if (data) {
            i18n.global.locale = data.locale as any;
        }
        this.$router.push({ path: '/onboarding/welcome' });
    }
    checkUserStatus(user: User) {
        if (user) {
            this.$router.push('/calendar/main');
        }
    }
};
